import React from 'react'

interface CustomizedLabelProps {
  x?: number
  y?: number
  stroke?: string
  value?: number
}

export const CustomizedLabel = ({
  value,
  x,
  y,
  stroke,
}: CustomizedLabelProps): JSX.Element => {
  return (
    <text
      x={x}
      y={y}
      fill={stroke}
      dy={-10}
      textAnchor='middle'
      fontSize={12}
      fontWeight='bold'
    >
      {value?.toString().replace('.', ',')}
    </text>
  )
}